export default __webpack_public_path__ + "static/media/RACA.a3e48724.svg";